import React, { Component } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Card, Button, Switch, List, message, Modal } from 'antd';
import { reqGetDetailClient, reqResetSecret } from '../../../../api';
import LinkButton from '../../../../components/link-button';
import PropTypes from 'prop-types';
import ShowRole from '../ShowRole';

const Item = List.Item;

class ClientDetail extends Component {
  static propTypes = {
    client: PropTypes.object,
  };
  state = {
    client: {},
  };

  // 查询客户端详情
  getClientDetail = async () => {
    const result = await reqGetDetailClient(this.props.location.state.id);
    if (result.status === 200) {
      this.setState({ client: result.result });
    }
  };

  resetSecret = async () => {
    Modal.confirm({
      content: '确定重置secret吗？',
      onOk: async () => {
        const result = await reqResetSecret({
          client_id: this.state.client.id,
        });
        if (result.status === 200) {
          message.success('重置成功');
          this.getClientDetail();
        } else {
          message.error(result.error);
        }
      },
    });
  };

  componentDidMount() {
    this.getClientDetail();
  }

  render() {
    const { client } = this.state;
    const extra = (
      <Button type="primary" onClick={this.resetSecret}>
        重置secret
      </Button>
    );
    const title = (
      <span>
        <LinkButton>
          <ArrowLeftOutlined
            style={{ marginRight: 10, fontSize: 20 }}
            onClick={() => this.props.history.goBack()}></ArrowLeftOutlined>
        </LinkButton>
        <span>客户端详情</span>
      </span>
    );
    return (
      <Card title={title} extra={extra}>
        <List className="client-detail">
          <Item>
            <span className="left">app_id：</span>
            <span>{client.app_id}</span>
          </Item>
          <Item>
            <span className="left">client_secret：</span>
            <span>{client.client_secret}</span>
          </Item>
          <Item>
            <span className="left">客户端名称：</span>
            <span>{client.client_name}</span>
          </Item>
          <Item>
            <span className="left">认证方式：</span>
            <span>{client.grant_type}</span>
          </Item>
          <Item>
            <span className="left">有效：</span>
            <span>
              <Switch defaultChecked={!(client.state === 'enabled')} />
            </span>
          </Item>
          <Item>
            <span className="left">角色列表：</span>
            <ShowRole client={client} />
          </Item>
        </List>
      </Card>
    );
  }
}

export default ClientDetail;
